export const loginFr = {
  "Username": "Nom d'utilisateur",
  "Password": "Mot de passe",
  "Connecter": "Connecter",
  "Wrong Data !": "Données erronées !",
  "Wrong Data !!": "Données erronées !!",
  "Gestion & Administration": "Gestion & Administration",
  "Espace Médecins": "Espace Médecins",
  "retourner à la page d'accueil": "retourner à la page d'accueil",

}